var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52539 2.42896C4.52539 2.15281 4.74925 1.92896 5.02539 1.92896H23.7084C23.9845 1.92896 24.2084 2.15281 24.2084 2.42896V21C24.2084 21.2761 23.9845 21.5 23.7084 21.5H5.02539C4.74925 21.5 4.52539 21.2761 4.52539 21V18.1429C4.52539 17.8668 4.74925 17.6429 5.02539 17.6429C5.30153 17.6429 5.52539 17.8668 5.52539 18.1429V20.5H23.2084V7.21396H5.02539C4.74925 7.21396 4.52539 6.9901 4.52539 6.71396V2.42896ZM23.2084 6.21396V2.92896H5.52539V6.21396H23.2084Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37598 0.5C9.65212 0.5 9.87598 0.723858 9.87598 1V3.86C9.87598 4.13614 9.65212 4.36 9.37598 4.36C9.09983 4.36 8.87598 4.13614 8.87598 3.86V1C8.87598 0.723858 9.09983 0.5 9.37598 0.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4199 0.5C19.6961 0.5 19.9199 0.723858 19.9199 1V3.86C19.9199 4.13614 19.6961 4.36 19.4199 4.36C19.1438 4.36 18.9199 4.13614 18.9199 3.86V1C18.9199 0.723858 19.1438 0.5 19.4199 0.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.376 0.5C14.6521 0.5 14.876 0.723858 14.876 1V3.86C14.876 4.13614 14.6521 4.36 14.376 4.36C14.0998 4.36 13.876 4.13614 13.876 3.86V1C13.876 0.723858 14.0998 0.5 14.376 0.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04286 6.20203C5.31901 6.20203 5.54286 6.42588 5.54286 6.70203C5.54286 10.7294 4.4443 13.6739 3.33408 15.6184C2.83411 16.4941 2.33273 17.1655 1.93017 17.641H19.2308C19.2403 17.632 19.2503 17.6224 19.2608 17.6123C19.3687 17.5081 19.5265 17.3478 19.7177 17.1298C20.1001 16.6939 20.6155 16.0284 21.1326 15.1226C22.1654 13.3137 23.2099 10.5386 23.2099 6.70203C23.2099 6.42588 23.4337 6.20203 23.7099 6.20203C23.986 6.20203 24.2099 6.42588 24.2099 6.70203C24.2099 10.7294 23.1113 13.6739 22.0011 15.6184C21.4467 16.5894 20.8906 17.3092 20.4694 17.7893C20.2588 18.0294 20.0817 18.2097 19.9553 18.3318C19.892 18.3929 19.8414 18.4394 19.8055 18.4715C19.7876 18.4875 19.7733 18.5 19.763 18.5089L19.7505 18.5196L19.7465 18.523L19.7451 18.5241C19.7449 18.5243 19.7441 18.525 19.4239 18.141L19.7441 18.525C19.6542 18.6 19.5409 18.641 19.4239 18.641H0.756862C0.546393 18.641 0.358459 18.5092 0.286765 18.3113C0.215193 18.1138 0.274765 17.8926 0.435767 17.7578L0.436593 17.7571L0.442332 17.7521C0.448235 17.747 0.45804 17.7385 0.471487 17.7264C0.498385 17.7024 0.539843 17.6644 0.593793 17.6123C0.701711 17.5081 0.859503 17.3478 1.05068 17.1298C1.43311 16.6939 1.9485 16.0284 2.46565 15.1226C3.49843 13.3137 4.54286 10.5386 4.54286 6.70203C4.54286 6.42588 4.76672 6.20203 5.04286 6.20203Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.684bd06b792a81f2616e81a9cc805d43.svg";
export { ForwardRef as ReactComponent };